/**
 * 工程基础配置
 */
import { CountryCode } from "@al/base-lib";

import AppType from "../enums/AppType";

// 默认国家配置
export const defaultCountryCodeConfig = {
  [AppType.Akulaku]: CountryCode.ID, // 印尼
  [AppType.Silvrrplus]: CountryCode.MY, // 印尼
  [AppType.Silvrr]: CountryCode.DE, // 德国
};
